
































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
class Card extends Vue {
  @Prop({
    type: String,
    default: '',
  })
  readonly number: string
}

export default Card
